import * as i0 from '@angular/core';
import { Injectable, Inject, Component, Optional, ViewChild, Input, NgModule } from '@angular/core';
import * as i3 from '@upr-web-primer/browser-detector';
import { BrowserDetectorModule } from '@upr-web-primer/browser-detector';
import * as i4 from '@upr-web-primer/carousel';
import * as i2 from '@upr-web-primer/viewport';
import { ViewportModule } from '@upr-web-primer/viewport';
import { get, isEmpty } from 'lodash-es';
import { BehaviorSubject, Subscription, fromEvent } from 'rxjs';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i6 from '@upr-web-primer/lazy-load';
import { LazyLoadModule } from '@upr-web-primer/lazy-load';

class TcmPictureService {
    constructor(baseUrl, appRegexs) {
        this.baseUrl = baseUrl;
        this.appRegexs = appRegexs;
        this.isRenderingComplete$ = new BehaviorSubject(false);
    }
    resetIsRenderingComplete() {
        this.isRenderingComplete$.next(false);
    }
    getDesktopUrl(component) {
        const url = get(component, 'EmbeddedValues.0.HightResolutionIMage.LinkedComponentValues.0.Multimedia.Url') ||
            get(component, 'Fields.NavThumbnail.LinkedComponentValues[0].Multimedia.Url') ||
            get(component, 'EmbeddedValues.0.Image.LinkedComponentValues.0.Multimedia.Url') ||
            get(component, 'LinkedComponentValues.0.Multimedia.Url') ||
            get(component, 'DesktopImage.LinkedComponentValues.0.Multimedia.Url') ||
            get(component, 'HightResolutionIMage.LinkedComponentValues.0.Multimedia.Url') ||
            get(component, 'HightResolutionImage') ||
            get(component, 'HightResolutionIMage');
        return url ? `${this.baseUrl}${url}` : '';
    }
    getTabletUrl(component) {
        const url = get(component, 'EmbeddedValues.0.DesktopTabletImage.LinkedComponentValues.0.Multimedia.Url') ||
            get(component, 'DesktopTabletImage.LinkedComponentValues.0.Multimedia.Url') ||
            get(component, 'DesktopTabletImage') ||
            get(component, 'TabletImage.LinkedComponentValues.0.Multimedia.Url') ||
            get(component, 'EmbeddedValues.0.HightResolutionIMage.LinkedComponentValues.0.Multimedia.Url');
        return url ? `${this.baseUrl}${url}` : '';
    }
    getMobileUrl(component) {
        const url = get(component, 'EmbeddedValues.0.MobileImage.LinkedComponentValues.0.Multimedia.Url') ||
            get(component, 'MobileImage.LinkedComponentValues.0.Multimedia.Url') ||
            get(component, 'MobileImage') ||
            get(component, 'MobileImage.LinkedComponentValues.0.Multimedia.Url') ||
            get(component, 'EmbeddedValues.0.DesktopTabletImage.LinkedComponentValues.0.Multimedia.Url') ||
            get(component, 'EmbeddedValues.0.HightResolutionIMage.LinkedComponentValues.0.Multimedia.Url');
        return url ? `${this.baseUrl}${url}` : '';
    }
    getOverrideUrl(url, width) {
        let newUrl = this.appRegexs.CONTENT_URL_EXP.test(url) && !url.includes(this.baseUrl)
            ? `${this.baseUrl}${url}`
            : url;
        newUrl = width ? `${newUrl}?imwidth=${width}` : newUrl;
        return newUrl;
    }
    getAlternateText(component) {
        return (get(component, 'AltText.Values.0') ||
            get(component, 'EmbeddedValues.0.AltText.Values.0') ||
            get(component, 'EmbeddedValues.0.HightResolutionIMage.LinkedComponentValues.0.Multimedia.AltText') ||
            get(component, 'EmbeddedValues.0.Image.LinkedComponentValues.0.Multimedia.AltText') ||
            get(component, 'LinkedComponentValues.0.Multimedia.AltText') ||
            get(component, 'AltText') ||
            get(component, 'LinkedComponentValues.0.MetadataFields.alt.Values.0') ||
            get(component, 'EmbeddedValues.0.HightResolutionIMage.LinkedComponentValues.0.MetadataFields.alt.Values.0') ||
            get(component, 'Fields.ImageTitle.EmbeddedValues[0].AltText.Values[0]') ||
            get(component, 'EmbeddedValues.0.Image.LinkedComponentValues.0.MetadataFields.alt.Values.0', ''));
    }
    getTitleText(component) {
        return (get(component, 'EmbeddedValues.0.ImageTitle.Values.0') ||
            get(component, 'EmbeddedValues.0.HightResolutionIMage.LinkedComponentValues.0.MetadataFields.title.Values.0') ||
            get(component, 'EmbeddedValues.0.Image.LinkedComponentValues.0.MetadataFields.title.Values.0') ||
            get(component, 'LinkedComponentValues.0.MetadataFields.title.Values.0') ||
            get(component, 'DesktopImage.LinkedComponentValues.0.Title') ||
            get(component, 'Title', ''));
    }
}
TcmPictureService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmPictureService, deps: [{ token: 'TridionBaseUrl' }, { token: 'AppRegexs' }], target: i0.ɵɵFactoryTarget.Injectable });
TcmPictureService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmPictureService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmPictureService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['TridionBaseUrl']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['AppRegexs']
                }] }]; } });

class TcmPictureComponent {
    constructor(picture, vp, browserDetector, zone, carouselService) {
        this.picture = picture;
        this.vp = vp;
        this.browserDetector = browserDetector;
        this.zone = zone;
        this.carouselService = carouselService;
        this.lazy = true;
        this.placeholder = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
        this.waitToLoad = true;
        this.loaded = false;
        this.isIE = false;
        this.media = {
            desktop: '61.25em',
            tablet: '37.5em'
        };
        this.$subscriptions = new Subscription();
        this.isIE = this.browserDetector.isIE();
        this.desktop = this.placeholder;
        this.tablet = this.placeholder;
        this.mobile = this.placeholder;
    }
    ngOnInit() {
        this.alt = this.picture.getAlternateText(this.data) || this.overrideAltText;
        this.title = this.picture.getTitleText(this.data) || this.overrideTitle;
        if (!this.lazy) {
            this.getImage();
        }
        else if (!this.carouselService) {
            this.$subscriptions.add(this.picture.isRenderingComplete$.subscribe((loader) => (this.waitToLoad = !loader)));
        }
    }
    ngAfterViewInit() {
        if (this.carouselService && this.lazy) {
            this.zone.runOutsideAngular(() => {
                this.$subscriptions.add(fromEvent(this.imageElem.nativeElement, 'load').subscribe(() => {
                    if (this.imageElem.nativeElement.src.indexOf(this.placeholder) === -1) {
                        this.carouselService.$triggerFixHeight.next(this.imageElem.nativeElement.height);
                    }
                }));
            });
            this.$subscriptions.add(this.carouselService.$loaded.subscribe((bool) => {
                if (bool) {
                    this.loaded = true;
                    this.getImage();
                }
            }));
        }
    }
    ngOnChanges() {
        if (this.loaded) {
            this.getImage();
        }
    }
    getImage() {
        if (this.carouselService && !this.loaded && this.lazy) {
            return;
        }
        if (!this.overrideImage) {
            let desktop = this.picture.getDesktopUrl(this.data);
            let tablet = this.picture.getTabletUrl(this.data) || desktop;
            let mobile = this.picture.getMobileUrl(this.data) || tablet || desktop;
            if (!isEmpty(this.settings)) {
                const desktopImgWidth = this.overrideWidth || get(this.settings, 'desktopImgWidth');
                const tabletImgWidth = this.overrideWidth || get(this.settings, 'tabletImgWidth');
                const mobileImgWidth = this.overrideWidth || get(this.settings, 'mobileImgWidth');
                if (desktop && desktopImgWidth) {
                    desktop = desktop + '?imwidth=' + desktopImgWidth;
                }
                if (tablet && tabletImgWidth) {
                    tablet = tablet + '?imwidth=' + tabletImgWidth;
                }
                if (mobile && mobileImgWidth) {
                    mobile = mobile + '?imwidth=' + mobileImgWidth;
                }
            }
            this.desktop = desktop;
            this.tablet = tablet;
            this.mobile = mobile;
            if (this.isIE && !this.imageUrl) {
                this.$subscriptions.add(this.vp.viewport$.subscribe((viewport) => {
                    const viewportImage = get(this, viewport.viewport);
                    if (viewportImage !== this.imageUrl) {
                        this.imageUrl = viewportImage;
                    }
                }));
            }
        }
        else {
            const overrideImage = this.picture.getOverrideUrl(this.overrideImage, this.overrideWidth);
            if (this.isIE) {
                this.imageUrl = overrideImage;
            }
            else {
                this.mobile = overrideImage;
            }
        }
        this.loaded = true;
    }
    ngOnDestroy() {
        if (this.$subscriptions && this.$subscriptions.unsubscribe) {
            this.$subscriptions.unsubscribe();
        }
    }
}
TcmPictureComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmPictureComponent, deps: [{ token: TcmPictureService }, { token: i2.ViewportService }, { token: i3.BrowserDetectorService }, { token: i0.NgZone }, { token: i4.CarouselService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
TcmPictureComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: TcmPictureComponent, selector: "tcm-picture", inputs: { lazy: "lazy", data: "data", settings: "settings", overrideImage: "overrideImage", overrideAltText: "overrideAltText", overrideTitle: "overrideTitle", overrideWidth: "overrideWidth", backgroundPicture: "backgroundPicture" }, viewQueries: [{ propertyName: "imageElem", first: true, predicate: ["imageElem"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"isIE; then image; else picture\"></ng-container>\r\n\r\n<ng-template #picture>\r\n\t<div\r\n\t\tclass=\"tcm-image-container\"\r\n\t\t[ngClass]=\"{ 'background-image': backgroundPicture }\"\r\n\t>\r\n\t\t<picture>\r\n\t\t\t<!-- 61.25em = 1024px -->\r\n\t\t\t<source\r\n\t\t\t\t*ngIf=\"!overrideImage\"\r\n\t\t\t\tmedia=\"(min-width: {{ media?.desktop }})\"\r\n\t\t\t\t[attr.srcset]=\"desktop\"\r\n\t\t\t/>\r\n\r\n\t\t\t<!-- 37.5em = 600px -->\r\n\t\t\t<source\r\n\t\t\t\t*ngIf=\"!overrideImage\"\r\n\t\t\t\tmedia=\"(min-width: {{ media?.tablet }})\"\r\n\t\t\t\t[attr.srcset]=\"tablet\"\r\n\t\t\t/>\r\n\r\n\t\t\t<source [attr.srcset]=\"mobile\" />\r\n\r\n\t\t\t<img\r\n\t\t\t\tclass=\"tcm-image\"\r\n\t\t\t\talt=\"{{ alt || '' }}\"\r\n\t\t\t\t[attr.title]=\"title\"\r\n\t\t\t\t[attr.src]=\"mobile\"\r\n\t\t\t\tuprLazyLoad\r\n\t\t\t\t[lazyOn]=\"lazy\"\r\n\t\t\t\t[wait]=\"waitToLoad\"\r\n\t\t\t\t[marginBottom]=\"100\"\r\n\t\t\t\t(deferLoad)=\"getImage()\"\r\n\t\t\t\t#imageElem\r\n\t\t\t/>\r\n\t\t</picture>\r\n\t</div>\r\n</ng-template>\r\n\r\n<ng-template #image>\r\n\t<div\r\n\t\tclass=\"tcm-image-container\"\r\n\t\t[ngClass]=\"{ 'background-image-ie': backgroundPicture }\"\r\n\t>\r\n\t\t<img\r\n\t\t\tclass=\"tcm-image\"\r\n\t\t\talt=\"{{ alt || '' }}\"\r\n\t\t\t[attr.title]=\"title\"\r\n\t\t\t[attr.src]=\"imageUrl\"\r\n\t\t\tuprLazyLoad\r\n\t\t\t[lazyOn]=\"false\"\r\n\t\t\t[wait]=\"waitToLoad\"\r\n\t\t\t(deferLoad)=\"getImage()\"\r\n\t\t\t#imageElem\r\n\t\t/>\r\n\t</div>\r\n</ng-template>\r\n", styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.tcm-image-container{width:100%}.tcm-image-container.background-image,.tcm-image-container.background-image .tcm-image{height:100%;object-fit:cover;object-position:center}.tcm-image-container.background-image-ie{background-size:cover;background-position:center}.tcm-image-container .tcm-image{width:100%}:host-context(.top-header-section) .tcm-image{width:auto}:host-context(.simple-mobile-header) .tcm-image{height:65px;width:auto}@media screen and (min-width: 62.5em){:host-context(.simple-mobile-header) .tcm-image{height:70px}}@media screen and (min-width: 62.5em){:host-context(.scale-image-vertically){height:100%}:host-context(.scale-image-vertically) .tcm-image-container{height:100%}:host-context(.scale-image-vertically) img{object-fit:cover;height:100%;width:100%}}:host-context(.top-header-logo) .tcm-image-container img{object-fit:contain;height:100%;width:auto}:host-context(.header-logo) .tcm-image-container{height:100%}:host-context(.header-logo) .tcm-image-container img{object-fit:contain;height:100%;width:auto}\n"], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.LazyLoadDirective, selector: "[uprLazyLoad]", inputs: ["lazyOn", "marginBottom", "wait"], outputs: ["deferLoad"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmPictureComponent, decorators: [{
            type: Component,
            args: [{ selector: 'tcm-picture', template: "<ng-container *ngIf=\"isIE; then image; else picture\"></ng-container>\r\n\r\n<ng-template #picture>\r\n\t<div\r\n\t\tclass=\"tcm-image-container\"\r\n\t\t[ngClass]=\"{ 'background-image': backgroundPicture }\"\r\n\t>\r\n\t\t<picture>\r\n\t\t\t<!-- 61.25em = 1024px -->\r\n\t\t\t<source\r\n\t\t\t\t*ngIf=\"!overrideImage\"\r\n\t\t\t\tmedia=\"(min-width: {{ media?.desktop }})\"\r\n\t\t\t\t[attr.srcset]=\"desktop\"\r\n\t\t\t/>\r\n\r\n\t\t\t<!-- 37.5em = 600px -->\r\n\t\t\t<source\r\n\t\t\t\t*ngIf=\"!overrideImage\"\r\n\t\t\t\tmedia=\"(min-width: {{ media?.tablet }})\"\r\n\t\t\t\t[attr.srcset]=\"tablet\"\r\n\t\t\t/>\r\n\r\n\t\t\t<source [attr.srcset]=\"mobile\" />\r\n\r\n\t\t\t<img\r\n\t\t\t\tclass=\"tcm-image\"\r\n\t\t\t\talt=\"{{ alt || '' }}\"\r\n\t\t\t\t[attr.title]=\"title\"\r\n\t\t\t\t[attr.src]=\"mobile\"\r\n\t\t\t\tuprLazyLoad\r\n\t\t\t\t[lazyOn]=\"lazy\"\r\n\t\t\t\t[wait]=\"waitToLoad\"\r\n\t\t\t\t[marginBottom]=\"100\"\r\n\t\t\t\t(deferLoad)=\"getImage()\"\r\n\t\t\t\t#imageElem\r\n\t\t\t/>\r\n\t\t</picture>\r\n\t</div>\r\n</ng-template>\r\n\r\n<ng-template #image>\r\n\t<div\r\n\t\tclass=\"tcm-image-container\"\r\n\t\t[ngClass]=\"{ 'background-image-ie': backgroundPicture }\"\r\n\t>\r\n\t\t<img\r\n\t\t\tclass=\"tcm-image\"\r\n\t\t\talt=\"{{ alt || '' }}\"\r\n\t\t\t[attr.title]=\"title\"\r\n\t\t\t[attr.src]=\"imageUrl\"\r\n\t\t\tuprLazyLoad\r\n\t\t\t[lazyOn]=\"false\"\r\n\t\t\t[wait]=\"waitToLoad\"\r\n\t\t\t(deferLoad)=\"getImage()\"\r\n\t\t\t#imageElem\r\n\t\t/>\r\n\t</div>\r\n</ng-template>\r\n", styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.tcm-image-container{width:100%}.tcm-image-container.background-image,.tcm-image-container.background-image .tcm-image{height:100%;object-fit:cover;object-position:center}.tcm-image-container.background-image-ie{background-size:cover;background-position:center}.tcm-image-container .tcm-image{width:100%}:host-context(.top-header-section) .tcm-image{width:auto}:host-context(.simple-mobile-header) .tcm-image{height:65px;width:auto}@media screen and (min-width: 62.5em){:host-context(.simple-mobile-header) .tcm-image{height:70px}}@media screen and (min-width: 62.5em){:host-context(.scale-image-vertically){height:100%}:host-context(.scale-image-vertically) .tcm-image-container{height:100%}:host-context(.scale-image-vertically) img{object-fit:cover;height:100%;width:100%}}:host-context(.top-header-logo) .tcm-image-container img{object-fit:contain;height:100%;width:auto}:host-context(.header-logo) .tcm-image-container{height:100%}:host-context(.header-logo) .tcm-image-container img{object-fit:contain;height:100%;width:auto}\n"] }]
        }], ctorParameters: function () { return [{ type: TcmPictureService }, { type: i2.ViewportService }, { type: i3.BrowserDetectorService }, { type: i0.NgZone }, { type: i4.CarouselService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { imageElem: [{
                type: ViewChild,
                args: ['imageElem']
            }], lazy: [{
                type: Input
            }], data: [{
                type: Input
            }], settings: [{
                type: Input
            }], overrideImage: [{
                type: Input
            }], overrideAltText: [{
                type: Input
            }], overrideTitle: [{
                type: Input
            }], overrideWidth: [{
                type: Input
            }], backgroundPicture: [{
                type: Input
            }] } });

class TcmPictureModule {
}
TcmPictureModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmPictureModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TcmPictureModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmPictureModule, declarations: [TcmPictureComponent], imports: [CommonModule,
        ViewportModule,
        BrowserDetectorModule,
        LazyLoadModule], exports: [TcmPictureComponent] });
TcmPictureModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmPictureModule, imports: [[
            CommonModule,
            ViewportModule,
            BrowserDetectorModule,
            LazyLoadModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmPictureModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ViewportModule,
                        BrowserDetectorModule,
                        LazyLoadModule
                    ],
                    declarations: [TcmPictureComponent],
                    exports: [TcmPictureComponent]
                }]
        }] });

export { TcmPictureComponent, TcmPictureModule, TcmPictureService };
